var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.626 2.73999H87.0002V16.332H119.626V2.73999Z",
    fill: "#E37D2A",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.217 10.8962H100.592V24.4883H133.217V10.8962Z",
    fill: "#3DDB15",
    fillOpacity: 0.275
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7829 108.542H0V116.927H40.7829V108.542Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 108.542H133.218V116.927H174V108.542Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7829 116.46H0V171.303H40.7829V116.46Z",
    fill: "#11119B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 116.46H133.218V171.303H174V116.46Z",
    fill: "#11119B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.94 78.8643H38.0637V87.0205H135.94V78.8643Z",
    fill: "#DFB4A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.375 70.7104H32.6255V78.8667H141.375V70.7104Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.812 70.7088H27.1877V59.8338L87.0001 40.8022L146.812 59.8338V70.7088Z",
    fill: "#D8455D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.221 87.0217H40.783V171.303H133.221V87.0217Z",
    fill: "#600CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7698 97.8979H54.4172V160.43H59.7698V97.8979Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.081 97.8979H70.7285V160.43H76.081V97.8979Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.395 97.8979H87.0425V160.43H92.395V97.8979Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.706 97.8979H103.354V160.43H108.706V97.8979Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.021 97.8979H119.668V160.43H125.021V97.8979Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 168.627H0V173.979H174V168.627Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.895 165.865H130.542V89.6973H43.4575V165.865H38.105V84.3447H135.895V165.865Z",
    fill: "#33B69A",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9373 97.8538H51.6985V160.47H48.9373V165.823H59.8122V160.47H57.051V97.8538H59.8122V92.5012H48.9373V97.8538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2498 97.8538H68.011V160.47H65.2498V165.823H76.1247V160.47H73.3635V97.8538H76.1247V92.5012H65.2498V97.8538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5623 97.8538H84.3238V160.47H81.5623V165.823H92.4372V160.47H89.6763V97.8538H92.4372V92.5012H81.5623V97.8538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8748 97.8538H100.636V160.47H97.8748V165.823H108.75V160.47H105.989V97.8538H108.75V92.5012H97.8748V97.8538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.062 97.8539V92.5014H122.301V92.4592H116.948V92.5014H114.187V97.8539H116.948V160.47H114.187V165.823H125.062V160.47H122.301V97.8539H125.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.375 76.1882H32.6255V81.5408H141.375V76.1882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3447 106.095H0V111.447H35.3447V106.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6764 38.8452V0.0212402H84.3239V38.8456L24.5112 57.8767V73.3848H149.488V57.8767L89.6764 38.8452ZM144.136 68.0323H29.8638V61.7904L86.9998 43.6108L144.136 61.7904V68.0323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.301 19.01H92.4373V13.6574H116.948V5.41624H92.4373V0.0637207H122.301V19.01Z",
    fill: "#770FDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.895 27.1662H106.031V21.8137H130.542V13.5725H125.063V8.21997H135.895V27.1662Z",
    fill: "#D3458B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6765 54.3958H84.324V59.8331H89.6765V54.3958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71533 119.506L32.6219 119.601L32.6391 114.249L2.73245 114.153L2.71533 119.506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71631 146.789L32.6229 146.885L32.64 141.532L2.73344 141.437L2.71631 146.789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5513 125.085H8.19873V135.96H13.5513V125.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1445 125.085H21.792V135.96H27.1445V125.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5513 152.272H8.19873V163.148H13.5513V152.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1445 152.272H21.792V163.148H27.1445V152.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 106.094H138.656V111.447H174V106.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.371 119.499L171.278 119.595L171.295 114.242L141.388 114.147L141.371 119.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.372 146.783L171.279 146.879L171.296 141.526L141.389 141.43L141.372 146.783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.208 125.085H146.856V135.96H152.208V125.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 125.085H160.447V135.96H165.8V125.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.208 152.272H146.856V163.148H152.208V152.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 152.272H160.447V163.148H165.8V152.272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 174,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollege);
export default __webpack_public_path__ + "static/media/college.165b559948fd59012051cf5ec6353236.svg";
export { ForwardRef as ReactComponent };